import { pageInfo, detailInfo, editSubmit, deleteBatch, exportData, upload, downLoadTemplate } from './../api';
import { getCarrierList, getDcNoList } from '../../../../api/selects';
const route = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    detailInfoObj: null,
    editSubmitObj: null,
    deleteBatchObj: null,
    exportObj: null,
    uploadObj: null,
    templateObj: null,
    carrierListObj: null,
    dcNoListObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({ ...item, btns: [true, true] }));
    },
    DETAIL_INFO(state, data) {
      state.detailInfoObj = data.obj || {};
    },
    EDIT_SUBMIT(state, data) {
      state.editSubmitObj = data;
    },
    DELETE_BATCH(state, data) {
      state.deleteBatchObj = data;
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    UPLOAD_DATA(state, data) {
      state.uploadObj = data;
    },
    DOWN_TEMPLATE(state, data) {
      state.templateObj = data;
    },
    CARRIER_LIST(state, data) {
      state.carrierListObj = data;
    },
    DCNO_LIST(state, data) {
      state.dcNoListObj = data;
    }
  },
  actions: {
    async pageInfo({ commit }, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async detailInfo({ commit }, obj) {
      let resp = await detailInfo(obj);
      commit('DETAIL_INFO', resp);
    },
    async editSubmit({ commit }, obj) {
      let resp = await editSubmit(obj);
      commit('EDIT_SUBMIT', resp);
    },
    async deleteBatch({ commit }, obj) {
      let resp = await deleteBatch(obj);
      commit('DELETE_BATCH', resp);
    },
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    async upload({ commit }, obj) {
      let resp = await upload(obj);
      commit('UPLOAD_DATA', resp);
    },
    async downLoadTemplate({ commit }, obj) {
      let resp = await downLoadTemplate(obj);
      commit('DOWN_TEMPLATE', resp);
    },
    async getCarrierList({ commit }, obj) {
      let resp = await getCarrierList(obj);
      commit('CARRIER_LIST', resp);
    },
    async getDcNoList({ commit }, obj) {
      let resp = await getDcNoList(obj);
      commit('DCNO_LIST', resp);
    }
  }
}
export default route



// WEBPACK FOOTER //
// ./src/page/md/route/store/route.store.js